import React, { useEffect, useState } from 'react';
import { Card, Alert, Spin } from 'antd';
import { getNotices } from '../services/notice';
import { useTranslation } from 'react-i18next';
import './Notice.css';

interface NoticeType {
  id: number;
  type: number;
  content: string;
  status: number;
  addtime: number;
  updatetime: number;
}

const Notice: React.FC = () => {
  const { t } = useTranslation();
  const [notices, setNotices] = useState<NoticeType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        setLoading(true);
        const response = await getNotices();
        console.log('公告数据:', response);
        if (response.code === 0) {
          setNotices(response.data || []);
        } else {
          setError(t('common.getNoticesFailed'));
        }
      } catch (error) {
        console.error('获取公告失败:', error);
        setError(t('common.getNoticesFailed'));
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, [t]);

  const fixedNotice = notices.find(n => n.type === 2 && n.status === 1);
  const scrollNotice = notices.find(n => n.type === 1 && n.status === 1);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message">
        {error}
      </div>
    );
  }

  if (!fixedNotice && !scrollNotice) {
    return (
      <div className="no-notice">
        {t('common.noNotices')}
      </div>
    );
  }

  return (
    <Card className="notice-card">
      <div className="notice-content">
        {fixedNotice && (
          <Alert
            className="notice-alert"
            message={fixedNotice.content}
            type="info"
            showIcon={false}
          />
        )}
        {scrollNotice && (
          <div className="scroll-notice">
            <div className="scroll-notice-text">
              {scrollNotice.content}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default Notice; 